module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ec-Fb-Gb.3cc15d8c.png";